import { WeatherApiQueryCopyIcon, WeatherScientistIcon } from '@/resource/IconComponentSets';
import { IWeatherQueryStationResModel } from '@/util/Request/requestType';
import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import './index.less';
import Copy from 'copy-to-clipboard';
import { useDispatch } from 'react-redux';
import { updateSuccessMessage } from '@/redux/reducer/common';
import IF from '@/components/IF';

interface IProps {
    queryData: IWeatherQueryStationResModel[]
    startDate: string
    endDate: string
}

interface IQueryDataShow {
    stations: string[]
    datefrom: string
    dateto: string
    supplier: string
    variables: string[]
    format: string
    frequency: string
}

const WeatherApiQueryComponent = (props: IProps) => {
    const {
        queryData,
        startDate,
        endDate,
    } = props;

    const [items, setItems] = useState<{
        label: string
        key: string
        children: JSX.Element}[]>();
    // const [currentTab, setCurrentTab] = useState<string>();
    // const [constructDownloadObj, setConstructDownloadObj] = useState<IQueryDataShow[]>();

    const dispatch = useDispatch();

    const copyApiQuery = (apiQuery: string) => {
        Copy(apiQuery);
        dispatch(updateSuccessMessage('Copy json success!'));
    };

    useEffect(() => {
        const newQueryDataShowed = queryData?.map((data) => {
            const stations = data.stations.map((station) => station.stationID);
            const newStartDate = startDate.split('/').reverse().join('');
            const newEndDate = endDate.split('/').reverse().join('');
            return {
                stations,
                frequency: data.frequency,
                supplier: data.supplier,
                variables: [data.variable],
                format: 'JSON',
                datefrom: newStartDate,
                dateto: newEndDate
            };
        });


        const items = newQueryDataShowed?.map((data) => {
            const key = `${data.supplier}-${data.variables}-${data.frequency}`;
            // if (index === 0) setCurrentTab(key);
            return {
                label: key, key, children: (
                    <div className='api-query-super-div'>
                        <div className='api-query-copy-div'>
                            <button onClick={() => copyApiQuery(JSON.stringify(data)) }><WeatherApiQueryCopyIcon /><span>Copy API Query</span></button>
                        </div>
                        <div className='api-query-content'>
                            <span className='query-span'>
                                {JSON.stringify(data, null, '\t')}
                            </span>
                        </div>
                    </div>
                )};
        });
        setItems(items);
    }, [queryData]);


    return (
        <div className='api-query-container'>
            <IF show={queryData && queryData.length > 0}>
                <Tabs
                    className='query-tabs-super-div'
                    items={items}
                    style={{ height: '100%'}}
                />
            </IF>
            <IF show={!(queryData && queryData.length > 0)}>
                <div className='weather-empty'>
                    <WeatherScientistIcon />
                </div>
            </IF>
        </div>
    );
};

export default WeatherApiQueryComponent;

export type {
    IQueryDataShow
};